/* eslint-disable */
import axios from "axios";
const url = require("../../client_config/config").url;
import { saveAs } from "file-saver";
import { showAlert } from "../../../utils/AlertHelper";

const itemName = ["contacts", "contact"];
const routes = "emergencyContact";

const state = {
  items: [],
  item: null,
  isLoading: false,
};

const getters = {
  getAllItems: (state) => state.items,
  isLoading: (state) => state.isLoading,
};

const actions = {
  async getItems({ commit }, userId) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/${routes}/staff/${userId}`);
      console.log(response);
      commit("SET_ITEMS", response.data.results);
    } catch (error) {
      console.error(`Error fetching ${itemName[0]}:`, error);
      showAlert("error", `fetching ${itemName[0]}`);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async getItem({ commit }, id) {
    commit("SET_LOADING", true);
    try {
      const response = await axios.get(`${url}/${routes}/${id}`);
      commit("SET_ITEM", response.data.results);
    } catch (error) {
      console.error(`Error fetching ${itemName[1]}:`, error);
      showAlert("error", `fetching ${itemName[1]}`);
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async addItem({}, data) {
    try {
      const response = await axios.post(`${url}/${routes}`, data);
      showAlert("added", itemName[1]);
      return response;
    } catch (error) {
      console.error(`Error adding ${itemName[1]}:`, error);
      showAlert("error", `adding ${itemName[1]}`);
      return error.response;
    }
  },

  async updateItem({}, { id, data }) {
    try {
      const response = await axios.put(`${url}/${routes}/${id}`, data);
      showAlert("updated", itemName[1]);
      return response;
    } catch (error) {
      console.error(`Error updating ${itemName[1]}:`, error);
      showAlert("error", `updating ${itemName[1]}`);
      return error.response;
    }
  },

  async deleteItem({ commit, dispatch }, { id, userId }) {
    try {
      const response = await axios.delete(`${url}/${routes}/${id}`);
      if (response.status === 200) {
        dispatch("getItems", userId);
        showAlert("deleted", itemName[1]);
      }
    } catch (error) {
      console.error(`Error deleting ${itemName[1]}:`, error);
      showAlert("error", `deleting ${itemName[1]}`);
    }
  },
};

const mutations = {
  SET_ITEMS(state, data) {
    state.items = data;
  },
  SET_ITEM(state, data) {
    state.item = data;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
